// The register's vocabulary (TX-US-0016/0022/0036): the categories and lifecycle statuses, as the
// screen names them. The codes are the API's; the labels are ours.

// The hint is what the add form's card says under the name.
export const CATEGORIES = [
  { code: 'SUPPLIER', label: 'Supplier', hint: 'Sells product to us' },
  { code: 'CUSTOMER', label: 'Customer', hint: 'Buys product from us' },
  { code: 'LOGISTICS', label: 'Logistics', hint: 'Moves product: trucks, rail, vessels' },
  { code: 'SERVICE_PROVIDER', label: 'Service provider', hint: 'Stores, clears or inspects product' },
];

// What kind of logistics company or service provider it is (TX-US-0041). Each belongs to one
// category, so the two Others are two codes. Mirrors CounterpartySubcategory in
// trex/counterparties/models.py.
export const SUBCATEGORIES = [
  { code: 'TRANSPORTER', label: 'Transporter', category: 'LOGISTICS' },
  { code: 'LOGISTICS_OTHER', label: 'Other', category: 'LOGISTICS' },
  { code: 'STORAGE', label: 'Storage', category: 'SERVICE_PROVIDER' },
  { code: 'CUSTOMS', label: 'Customs', category: 'SERVICE_PROVIDER' },
  { code: 'SERVICE_OTHER', label: 'Other', category: 'SERVICE_PROVIDER' },
];

export const subcategoriesOf = (category) => SUBCATEGORIES.filter((s) => s.category === category);

export const subcategoryLabel = (code) => SUBCATEGORIES.find((s) => s.code === code)?.label ?? code;

// The subcategories whose category is still ticked: unticking a category drops its own.
export const keptSubcategories = (categories, subcategories) => subcategories.filter(
  (code) => categories.includes(SUBCATEGORIES.find((s) => s.code === code)?.category),
);

// In onboarding order (TX-US-0042). KYC approved is the counterparty standing at Risk.
export const STATUSES = [
  { code: 'PROSPECT', label: 'Prospect' },
  { code: 'KYC_APPROVED', label: 'KYC approved' },
  { code: 'LEGAL_REVIEW', label: 'Legal review' },
  { code: 'OVERRIDE_REQUESTED', label: 'Rejected by Legal, referred' },
  { code: 'APPROVED', label: 'Approved' },
  { code: 'REJECTED', label: 'Rejected' },
];

// Who owns each gate, by the status of the counterparty standing at it: the owner moves it on,
// back or out, and ADMIN alone returns a rejected one to prospect (TX-US-0036, TX-US-0042).
// Mirrors GATE_OWNERS in trex/counterparties/models.py.
export const GATE_OWNERS = {
  PROSPECT: 'COMPLIANCE',
  KYC_APPROVED: 'RISK',
  LEGAL_REVIEW: 'LEGAL',
  OVERRIDE_REQUESTED: 'LEGAL',
  REJECTED: 'ADMIN',
};

// How a counterparty that is not on the approved list is marked where one is picked for a deal,
// so picking it is an informed choice: a word on a suggestion, a clause under a linked field. One
// part way through onboarding (TX-US-0042) is marked as a prospect is.
const IN_ONBOARDING = { word: 'not approved', clause: 'in onboarding, not yet approved' };
const PICKER_MARKS = {
  PROSPECT: { word: 'prospect', clause: 'a prospect, not yet approved' },
  KYC_APPROVED: IN_ONBOARDING,
  LEGAL_REVIEW: IN_ONBOARDING,
  OVERRIDE_REQUESTED: IN_ONBOARDING,
  REJECTED: { word: 'rejected', clause: 'rejected' },
};

export const pickerMark = (status) => PICKER_MARKS[status] ?? null;

export const categoryLabel = (code) => CATEGORIES.find((c) => c.code === code)?.label ?? code;
export const statusLabel = (code) => STATUSES.find((s) => s.code === code)?.label ?? code;
